var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.405 5.333)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F1941",
    d: "M10.98 0c2.6 0 4.706 2.107 4.706 4.706v32.2a9.389 9.389 0 013.138 7.016c0 5.198-4.214 9.411-9.412 9.411S0 49.12 0 43.922a9.388 9.388 0 013.137-7.015V4.706C3.137 2.106 5.244 0 7.843 0h3.137zM9.412 3.137a3.137 3.137 0 00-3.137 3.138v32.211a6.275 6.275 0 106.274 0V6.275a3.138 3.138 0 00-3.137-3.138z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.412,
    cy: 43.922,
    r: 4.706,
    fill: "#FFB511"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.137,
    height: 28.235,
    x: 7.843,
    y: 17.255,
    fill: "#FFB511",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.549,
    height: 3.137,
    x: 17.255,
    y: 4.706,
    fill: "#E74536",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.549,
    height: 3.137,
    x: 17.255,
    y: 15.373,
    fill: "#E74536",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.549,
    height: 3.137,
    x: 17.255,
    y: 26.039,
    fill: "#2175D9",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.275,
    height: 3.137,
    x: 17.255,
    y: 10.039,
    fill: "#E74536",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.275,
    height: 3.137,
    x: 17.255,
    y: 20.706,
    fill: "#2175D9",
    rx: 1.569
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.275,
    height: 3.137,
    x: 17.255,
    y: 31.373,
    fill: "#2175D9",
    rx: 1.569
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgRiskTemperature as ReactComponent };